"use client";

import { Dialog, DialogTrigger, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { Icons } from "@/components/icons";
import React, { useEffect } from "react";
import { useState } from "react";
import Image from "next/image";
import { ProfileSubscribeForm } from "./profile-subscribe-form";
import { Avatar } from '@/components/avatar';


interface ProfileSubscribeDialogProps {
    userId: string;
    slug: string;
    name: string | null;
    profileImageUrl: string | null;
    hexColour: string;
}

export function ProfileSubscribeDialog({ slug, profileImageUrl, name, userId, hexColour }: ProfileSubscribeDialogProps) {
    const dialogRef = React.useRef<HTMLButtonElement | null>(null);
    const [isScrolled, setIsScrolled] = useState(false);
    let altName = slug + '\'s profile image' || 'profile image';
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        const checkScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener('scroll', checkScroll);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', checkScroll);
        };
    }, []); // Empty dependency array means this effect runs once on mount and clean up on unmount

    return (
        <div className="fixed top-4 right-4 z-50">
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger ref={dialogRef}>
            <div className="bg-white rounded-full p-2 shadow-[0px_4px_16px_rgba(17,17,26,0.1),_0px_8px_24px_rgba(17,17,26,0.1),_0px_16px_56px_rgba(17,17,26,0.1)] flex">
                <Icons.bell className={`transition-all duration-500 ${isScrolled ? 'ml-0' : 'ml-2'}`} width="24" height="24" fill="#000" />
                <span className={`text-md font-semibold transition-all duration-500 overflow-hidden ${isScrolled ? 'max-w-0 opacity-0 ml-0 mr-0' : 'max-w-full opacity-100 ml-2 mr-2'}`} style={{ transitionDelay: isScrolled ? '0s, 0.5s' : '0s, 0.5s' }}>Subscribe</span>
            </div>
            </DialogTrigger>
            <DialogContent className="h-full sm:h-auto">
                <DialogHeader className="flex items-center justify-center space-y-4 mx-4">
                <div className="relative bg-white rounded-full border-2 border-white shadow-xl overflow-hidden w-20 h-20">
                    {profileImageUrl ? (
                        <Image 
                            src={profileImageUrl} 
                            alt={altName} 
                            width={128} 
                            height={128} 
                            className="absolute inset-0 w-full h-full object-cover" 
                        />
                    ) : (
                        <Avatar name={name || slug} size="md" className="w-full h-full" colorise />
                    )}
                </div>
                <span className="text-xl text-zinc-800 font-bold">Subscribe to {name || slug}</span>
                <span className="text-sm text-zinc-800">Don&#39;t miss out! Stay up to date with everything important.</span>
                </DialogHeader>
                <ProfileSubscribeForm slug={slug} userId={userId} setOpen={setOpen} name={name} hexColour={hexColour} />
                {/* Only show MobileShareButton on mobile devices */}
                {/* <div className="sm:hidden">
                    <MobileShareButton title={"Share this SuperStack"} slug={slug} />
                </div>
                <InputWithButton inputValue={absoluteUrl(slug)} hexColour={hexColour} textColour={textColour} />
                <Separator className="my-4 border"/> */}
              {/* <DialogTitle>Create your own SuperStack</DialogTitle>
              <DialogDescription>
                Turn praise into business
              </DialogDescription> */}
              {/* Add any additional Dialog components you need here */}
              {/* <DialogFooter> */}
                {/* <div className="flex flex-col space-y-2">
                    <Link style={{ backgroundColor: hexColour, color: textColour }} href="/register" className="px-4 py-2 my-2 text-center text-white rounded">
                        Sign up free
                    </Link>
                    <Link style={{ borderColor: hexColour }} href="/" className="px-4 py-2 my-2 text-center text-black border rounded">
                        Find out more
                    </Link>
                </div> */}
                {/* </DialogFooter> */}
            </DialogContent>
          </Dialog>
        </div>
      );
}